import React from "react";
import { Mutation } from "react-apollo";
import InteractiveReportForm from "./InteractiveReportForm";
import gql from "graphql-tag";

const CREATE_INTERACTIVE_REPORT = gql`
  mutation CreateInteractiveReport(
    $interactiveReport: InteractiveReportInput!
  ) {
    createInteractiveReport(interactiveReport: $interactiveReport) {
      interactiveReport {
        id
        name
        slug
        description
        fileName
        roles
      }
      message
    }
  }
`;
interface InteractiveReport {
  name: string;
  slug: string;
  description: string;
  fileName: string;
  roles: string[];
}
interface CreateInteractiveReportMutationResults {
  createInteractiveReport: InteractiveReport;
  message: string;
}

interface CreateInteractiveReportMutationVariables {
  interactiveReport: InteractiveReport;
}

const CreateInteractiveReport = (): JSX.Element => {
  return (
    <Mutation<
      CreateInteractiveReportMutationResults,
      CreateInteractiveReportMutationVariables
    >
      mutation={CREATE_INTERACTIVE_REPORT}
    >
      {(createInteractiveReport) => {
        return <InteractiveReportForm mutationFn={createInteractiveReport} />;
      }}
    </Mutation>
  );
};

export default CreateInteractiveReport;
